module.exports = {"460107001":"国兴街道","460107002":"府城街道","460107003":"滨江街道","460107004":"凤翔街道","460107101":"龙塘镇","460107102":"云龙镇","460107103":"红旗镇","460107104":"三门坡镇","460107105":"大坡镇","460107106":"甲子镇","460107107":"旧州镇","460107500":"省岭脚热带作物场","460107501":"省长昌煤矿"}


//////////////////
// WEBPACK FOOTER
// ./src/town/460107.json
// module id = 2314
// module chunks = 0